import Notify from './notifyActions'
import {GET_APP_SETTING} from "../reducers/appSettingReducer";

export const APP_SETTINGS_UPDATE_SUCCESSFUL_TOAST = 'success_saving_settings'
export const APP_SETTINGS_UPDATE_FAILURE_TOAST = 'error_saving_settings'

export const getAppSetting = () => {
  return {
    type: GET_APP_SETTING,
    payload: {
      request: {
        mode: 'no-cors',
        url: `app-settings`,
        method: 'GET'
      }
    }
  }
}

export const UPDATE_FILE_UPLOAD_SETTINGS = 'UPDATE_FILE_UPLOAD_SETTINGS';
export const updateFileUploadSettings = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: UPDATE_FILE_UPLOAD_SETTINGS,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'app-settings/file-upload-settings',
            method: 'PUT',
            data: {request: data}
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(APP_SETTINGS_UPDATE_SUCCESSFUL_TOAST))
          resolve();
        } else {
          reject(response.payload.data);
        }
      }).catch(error => {
        dispatch(Notify.error(APP_SETTINGS_UPDATE_FAILURE_TOAST))
        reject(error);
      });
    });
  };
};

export const UPDATE_ACCOUNT_LOCKOUT_SETTINGS = 'UPDATE_ACCOUNT_LOCKOUT_SETTINGS';
export const updateAccountLockoutSettings = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: UPDATE_ACCOUNT_LOCKOUT_SETTINGS,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'app-settings/account-lockout',
            method: 'PUT',
            data: {request: data}
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(APP_SETTINGS_UPDATE_SUCCESSFUL_TOAST))
          resolve();
        } else {
          reject(response.payload.data);
        }
      }).catch(error => {
        dispatch(Notify.error(APP_SETTINGS_UPDATE_FAILURE_TOAST))
        reject(error);
      });
    });
  };
};




// WEBPACK FOOTER //
// ./src/redux/actions/appSettingActions.js